import { render, staticRenderFns } from "./CreateFeed.vue?vue&type=template&id=18d316d2&"
import script from "./CreateFeed.vue?vue&type=script&lang=js&"
export * from "./CreateFeed.vue?vue&type=script&lang=js&"
import style0 from "./CreateFeed.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports